import {mapGetters} from 'vuex';

export const menusMixin = {

    computed: {
        ...mapGetters('menus', {
            '$_getMenuName': 'getName',
            '$_getMenuSeo': 'getSeo',
        }),
    },
}
